import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import SearchInviteTab from "./SearchInviteTab";
import EmailInviteTab from "./EmailInviteTab";

const InviteModal = ({ isOpen, onClose, mode, clinicId, clinicCountryId, onSuccess }) => {
  const { t, i18n } = useTranslation();
  const [activeTab, setActiveTab] = useState("search");

  if (!isOpen) return null;

  const isVetMode = mode === "veterinarian";

  return (
    <div
      className="team-modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      dir={i18n.dir()}
      lang={i18n.language}
    >
      <div className="team-modal">
        <div className="team-modal-header">
          <h3 className="team-modal-title">
            {isVetMode
              ? t("manageTeam.invite.vetModalTitle", "Invite Veterinarian")
              : t("manageTeam.invite.moderatorModalTitle", "Invite Clinic Moderator")}
          </h3>
          <button type="button" className="team-modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="team-modal-body">
          {isVetMode ? (
            <>
              <div className="team-modal-tabs">
                <button
                  type="button"
                  className={`team-modal-tab ${activeTab === "search" ? "active" : ""}`}
                  onClick={() => setActiveTab("search")}
                >
                  {t("manageTeam.invite.tabs.search", "Search Existing")}
                </button>
                <button
                  type="button"
                  className={`team-modal-tab ${activeTab === "email" ? "active" : ""}`}
                  onClick={() => setActiveTab("email")}
                >
                  {t("manageTeam.invite.tabs.email", "Invite by Email")}
                </button>
              </div>
              <div className="team-tab-panel">
                {activeTab === "search" ? (
                  <SearchInviteTab
                    clinicId={clinicId}
                    clinicCountryId={clinicCountryId}
                    onSuccess={onSuccess}
                    onClose={onClose}
                  />
                ) : (
                  <EmailInviteTab
                    clinicId={clinicId}
                    userType="VETERINARIAN"
                    onSuccess={onSuccess}
                    onClose={onClose}
                  />
                )}
              </div>
            </>
          ) : (
            <div className="team-tab-panel">
              <EmailInviteTab
                clinicId={clinicId}
                userType="CLINIC_MODERATOR"
                onSuccess={onSuccess}
                onClose={onClose}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InviteModal;
